import { AGENT_END_REASON, HISTORY_TRANSIFY_KEY } from '@/utils/constants';
import { TRACKING_OPERATION, TRACKING_TARGET } from '@/utils/tracking/constants';
import { getTrans } from '@/utils/instantLoaded/tools';
import coreStore from '@/stores/core';

import React from 'react';
import { dispatchTrack } from '@/utils/tracking';

export const handleTerminalConfict = (() => {
  let modalInstance; // 保证只有一个实例，不要显示出多个

  return function generateModal() {
    const initStore = coreStore.safeGetStore('initStore');
    if (modalInstance || initStore.loadingToGetI18N) { return; }

    dispatchTrack({
      operation: TRACKING_OPERATION.IMPRESSION,
      target: TRACKING_TARGET.chatSessionConflict,
    });

    // @MARK: lazyLoad: ConfirmModal
    modalInstance = import('@/components/General/ConfirmModal').then(({ default: ConfirmModal }) => {
      ConfirmModal({
        className: 'terminal-conflict',
        title: getTrans(HISTORY_TRANSIFY_KEY.MODAL_TITLE_NOTICE),
        content: <div className="content">{getTrans(HISTORY_TRANSIFY_KEY.MULTI_TERMINAL_CONFLICT)}</div>,
        footer: [{
          value: getTrans(HISTORY_TRANSIFY_KEY.MODAL_OK_TEXT),
          type: 'primary',
        }],
        onFooterClick: async ({ value }) => {
          if (value === getTrans(HISTORY_TRANSIFY_KEY.MODAL_OK_TEXT)) {
            // 等待store装载完毕
            await coreStore.fullStorePromise;
            const agentStore = coreStore.safeGetStore('agentStore');
            if (agentStore.loadingInAgent || agentStore.inAgent) {
              agentStore.FINISH_LOADING_IN_AGENT();
              agentStore.END_AGENT(AGENT_END_REASON.OTHER);

              // @MARK: lazyLoad: { addUserCloseSession }
              import('@/utils/agent').then(({ addUserCloseSession }) => {
                addUserCloseSession();
              });

              // @MARK: lazyLoad: { chatEnd }
              import('./chat').then(({ chatEnd }) => {
                chatEnd(agentStore.sessionKey);
              });
            }

            // @MARK: lazyLoad: { handleTapBack }
            import('@/utils/handleTapBack').then(({ handleTapBack }) => {
              handleTapBack();
            });
          }
        },
      });
    });
  };
})();
